import PriceCalculator from './PriceCalculator';
const COMPONENT_SELECTOR = '[data-price-component]';
const WRAPPER_SELECTOR = '[data-price-input-wrapper]';
const PRICE_INPUT_SELECTOR = '[data-price-input]';
const DATA_GST_REGISTERED = 'gst-registered';
const DATA_GST = 'gst-value';
const SUBTOTAL_SELECTOR = '[data-subtotal]';
const QUANTITY_SELECTOR = '[data-quantity-field]';
const GST_ELEMENT_SELECTOR = `[data-${DATA_GST}]`;
const DATA_MARKETPLACE_FEE = 'marketplace-fee';
const DATA_MERCHANT_FEE = 'merchant-fee';
const MARKETPLACE_FEE_ELEMENT_SELECTOR = `[data-${DATA_MARKETPLACE_FEE}]`;
const MERCHANT_FEE_ELEMENT_SELECTOR = `[data-${DATA_MERCHANT_FEE}]`;
const TOTAL_ELEMENT_SELECTOR = '[data-total-marketplace-fee]';

class PriceInput {
  static numberWithCommas(price) {
    return (
      '$' +
      parseFloat(price)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
  }
  constructor() {
    if ($(COMPONENT_SELECTOR).size()) {
      this.attachEventHandlers();
    }
    $(PRICE_INPUT_SELECTOR).each((index, el) => {
      $(el).change();
    });
  }

  attachEventHandlers() {
    $(COMPONENT_SELECTOR).on(
      'change',
      PRICE_INPUT_SELECTOR,
      this.updateCalculations
    );
    $(COMPONENT_SELECTOR).on(
      'change',
      QUANTITY_SELECTOR,
      this.updateCalculations
    );

    $('body').on('cocoon:after-insert', (event, $addedPriceInput) => {
      if ($addedPriceInput.find(PRICE_INPUT_SELECTOR).size() > 0) {
        $addedPriceInput.find(PRICE_INPUT_SELECTOR).each((index, el) => {
          $(el).change();
        });
      }
    });
  }

  updateCalculations(event) {
    let merchantFeeRate = 0;
    const $wrapper = $(event.currentTarget)
      .closest(WRAPPER_SELECTOR)
      .eq(0);
    const $price = $wrapper.find(PRICE_INPUT_SELECTOR);
    const $quantity_field = $wrapper.find(QUANTITY_SELECTOR);
    const $marketplaceFee = $wrapper.find(MARKETPLACE_FEE_ELEMENT_SELECTOR);
    const $gst = $wrapper.find(GST_ELEMENT_SELECTOR);
    const $total = $wrapper.find(TOTAL_ELEMENT_SELECTOR);
    const $subtotal = $wrapper.find(SUBTOTAL_SELECTOR);

    const $merchantFee = $wrapper.find(MERCHANT_FEE_ELEMENT_SELECTOR);
    const marketplaceFeeRate = $marketplaceFee.data(DATA_MARKETPLACE_FEE);
    const isGSTRegistered = $price.data(DATA_GST_REGISTERED);
    let gstRate = 0;
    let quantity = 1;
    if ($merchantFee) {
      merchantFeeRate = parseFloat($merchantFee.data(DATA_MERCHANT_FEE));
    }
    if (isGSTRegistered) {
      gstRate = $gst.data(DATA_GST);
    }
    if ($quantity_field.length > 0) {
      quantity = $quantity_field.val();
    }

    let price = Math.ceil(parseFloat($price.val() * 100)) / 100;
    if (isNaN(price) || price < 0) {
      price = 0.0;
    }
    $price.val(price);

    let _priceCalculator = new PriceCalculator(
      price,
      quantity,
      merchantFeeRate,
      marketplaceFeeRate,
      gstRate
    );

    if ($subtotal) {
      $subtotal.html(PriceInput.numberWithCommas(_priceCalculator.subtotal()));
    }
    $merchantFee.html(
      PriceInput.numberWithCommas(_priceCalculator.merchantFee())
    );
    $marketplaceFee.html(
      PriceInput.numberWithCommas(_priceCalculator.marketplaceFee())
    );
    $gst.html(PriceInput.numberWithCommas(_priceCalculator.gst()));
    $total
      .html(PriceInput.numberWithCommas(_priceCalculator.totalChargeable()))
      .trigger('price_changed');
  }
}

export default PriceInput;



// WEBPACK FOOTER //
// ./src/javascripts/PriceInput.js